import "core-js";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import allReducers from "./reducers";

import * as serviceWorker from "./registerServiceWorker";

import "./library/js/string";
import "./library/js/number";

import "./library/pure-css/core/base.css";
import "./library/pure-css/core/forms.css";
import "./library/pure-css/core/grids.css";
import "./library/pure-css/core/grids-responsive.css";

import "./library/pure-css/custom/base.css";
import "./library/pure-css/custom/forms.css";
import "./library/pure-css/custom/grids.css";
import "./library/pure-css/custom/grids-responsive.css";

import "./library/css/core/style.css";
import "./library/css/core/buttons.css";
import "./library/css/core/text.css";
import "./library/css/core/icons.css";
import "./library/css/core/iframes.css";
import "./library/css/core/dialogs.css";
import "./library/css/core/modals.css";

import "./library/css/custom/style.css";
import "./library/css/custom/buttons.css";
import "./library/css/custom/text.css";
import "./library/css/custom/icons.css";
import "./library/css/custom/iframes.css";
import "./library/css/custom/dialogs.css";
import "./library/css/custom/modals.css";

/* Custom - Gourmet Grammar (167) */
import "./library/css/custom/custom-projects/gourmet-grammar/style.css";
import "./library/css/custom/custom-projects/gourmet-grammar/buttons.css";
import "./library/css/custom/custom-projects/gourmet-grammar/text.css";
import "./library/css/custom/custom-projects/gourmet-grammar/icons.css";
import "./library/css/custom/custom-projects/gourmet-grammar/iframes.css";
import "./library/css/custom/custom-projects/gourmet-grammar/dialogs.css";
import "./library/css/custom/custom-projects/gourmet-grammar/modals.css";

import SingleProjectApp from "App/SingleProjectApp";
import MultipleProjectApp from "App/MultipleProjectApp";

import { SINGLE_PROJECT_APP } from "config";

/* App Version Management */
import packageJson from ".././package.json";
global.appVersion = packageJson.version;

export const store = createStore(allReducers, applyMiddleware(thunk));

// store.subscribe(() => {
//   const state = store.getState();
//   console.log(state);
// });

const App = SINGLE_PROJECT_APP ? SingleProjectApp : MultipleProjectApp;

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root") || document.createElement("div")
);

serviceWorker.unregister();
